import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Table, Form, Button, Modal, Tooltip, Typography } from "antd";
import DynamicItemForm from "./DynamicItemForm";
import { PlusOutlined, DeleteOutlined, FormOutlined } from "@ant-design/icons";
import RestrictedContext from "../util/RestrictedContext";
var unflatten = require("flat").unflatten;
const { Text } = Typography;
const TableComponent = ({
  value,
  onChange,
  disabled,
  dataSource,
  addText,
  tableItems,
  formItems,
  category,
  name,
  twoColumns,
  emptyImg,
  resource,
  action,
  onFormChange,
  getInitialItem,
  hideAddButton,
  setFormMode,
  setFormActiveItem,
  sorter,
  titleText,
  onSubmit,
  disableStatus,
}) => {
  const [columns, setColumns] = useState([]);
  const [visible, setVisible] = useState(false);
  const [mode, setMode] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [activeKey, setActiveKey] = useState(null);
  const [tableData, setTableData] = useState([]);
  const restricted = useContext(RestrictedContext);

  useEffect(() => {
    let arr = [];
    if (value && value.length > 0) {
      value.forEach((item, i) => {
        const temp = {
          ...item,
          key: i,
        };
        arr.push(temp);
      });
    }
    setTableData(arr);
  }, [value]);

  useEffect(() => {
    let tableColumns = [];
    tableItems.forEach(function (item) {
      const title = "app.forms." + category + "." + name + "." + item.title;
      const j = item.render
        ? {
            title: <FormattedMessage id={title} />,
            dataIndex: item.title,
            responsive: item.responsive,
            width: item.width ? item.width : "auto",
            ellipsis: item.ellipsis,
            defaultSortOrder: item.defaultSortOrder,
            sorter: item.sorter,
            render: (text, record, index) => {
              const Comp = item.render;
              return (
                <Comp
                  category={category}
                  record={item.subRecord ? record[item.subRecord] : record}
                  text={text}
                  ellipsis={item.ellipsis}
                  {...item.columnProps}
                />
              );
            },
          }
        : {
            title: <FormattedMessage id={title} />,
            dataIndex: item.title,
            responsive: item.responsive,
            width: item.width ? item.width : "auto",
            ellipsis: {
              showTitle: item.ellipsis ? false : true,
            },
            render: (text, record, index) =>
              item.ellipsis ? (
                <Tooltip className="content" placement="topRight" title={text}>
                  {text}
                </Tooltip>
              ) : (
                <div className="content">{text}</div>
              ),
          };

      tableColumns.push(j);
    });
    if (restricted["hasWritePermission"]) {
      tableColumns.push({
        title: (
          <FormattedMessage
            id={"app.forms." + category + "." + name + ".actions"}
          />
        ),
        dataIndex: "actions",
        width: "120px",
        render: (item, record, index) => (
          <div>
            <Button
              type="link"
              onClick={() => {
                onDeleteRow(record, index);
              }}
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Button>
            <Button
              type="link"
              onClick={() => {
                onEditRow(record, index);
              }}
            >
              <FormOutlined style={{}} />
            </Button>
          </div>
        ),
      });
    }

    setColumns(tableColumns);
  }, [tableData]);

  const onDeleteRow = (item, index) => {
    var arr = tableData.filter((entry) => entry.key !== item.key);
    onChange(arr);
    setActiveKey(null);
  };

  const onEditRow = (item, index) => {
    setActiveItem(item);
    setActiveKey(item.key);
    setMode("edit");
    if (setFormMode) {
      setFormMode("edit");
    }
    if (setFormActiveItem) {
      setFormActiveItem(item);
    }
    setVisible(true);
  };

  const onAddClick = () => {
    setVisible(true);
    setMode("new");
    if (setFormMode) {
      setFormMode("new");
    }
  };

  const onDecline = () => {
    setVisible(false);
  };

  const onFinish = (values, mode) => {
    setVisible(false);
    setActiveItem(null);
    setMode(null);
    var result = name.split(".");
    const newRecord =
      result.length > 1
        ? unflatten(values, { safe: true })[result[0]][result[1]]
        : unflatten(values, { safe: true })[result[0]];
    const newKey = tableData ? tableData.reduce((a, b) => +a + +b.key, 0) : 1;
    const newVal = tableData
      ? mode === "edit"
        ? [
            ...tableData.filter((item) => item.key !== activeKey),
            { ...newRecord, key: newKey },
          ]
        : [...tableData, { ...newRecord, key: newKey }]
      : [{ ...newRecord, key: newKey }];

    if (sorter && newVal) {
      newVal.sort(sorter);
    }
    onChange(newVal);
    setActiveKey(null);
    if (onSubmit) {
      onSubmit(tableData, newRecord, activeKey, onChange);
    }
  };
  return (
    <div>
      {restricted["hasWritePermission"] &&
      (hideAddButton === undefined || !hideAddButton()) ? (
        <Button
          onClick={onAddClick}
          type="dashed"
          style={{
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
          }}
          icon={<PlusOutlined />}
          disabled={disableStatus}
        >
          <Text style={{ padding: "0 6px" }}>{addText}</Text>
        </Button>
      ) : null}

      {value && value.length > 0 ? (
        <Table
          bordered
          columns={columns}
          dataSource={tableData}
          size="small"
          disabled={disabled}
          rowKey={(record) => record.key}
        />
      ) : (
        emptyImg
      )}

      <Modal
        closable={false}
        footer={null}
        maskClosable={false}
        title={null}
        width={"fit-content"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        open={visible}
        destroyOnClose={true}
      >
        <DynamicItemForm
          resource={resource}
          action={action}
          record={formItems ? formItems : tableItems}
          category={category}
          name={name}
          onFinish={onFinish}
          onDecline={onDecline}
          addText={addText}
          titleText={titleText}
          twoColumns={twoColumns}
          mode={mode}
          activeItem={activeItem}
          onFormChange={onFormChange}
          getInitialItem={getInitialItem}
        />
      </Modal>
    </div>
  );
};

const DynamicItem = (props) => {
  const {
    name,
    category,
    addText,
    tableItems,
    formItems,
    twoColumns,
    emptyImg,
    resource,
    action,
    onFormChange,
    getInitialItem,
    hideAddButton,
    setFormMode,
    setFormActiveItem,
    titleText,
    sorter,
    onFinish,
    disabled,
  } = props;

  return (
    <Form.Item name={name}>
      <TableComponent
        tableItems={tableItems}
        formItems={formItems}
        size="small"
        addText={addText}
        category={category}
        name={name}
        twoColumns={twoColumns}
        emptyImg={emptyImg}
        resource={resource}
        action={action}
        onFormChange={onFormChange}
        getInitialItem={getInitialItem}
        hideAddButton={hideAddButton}
        setFormMode={setFormMode}
        setFormActiveItem={setFormActiveItem}
        sorter={sorter}
        titleText={titleText}
        onSubmit={onFinish}
        disableStatus={disabled}
      />
    </Form.Item>
  );
};

DynamicItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
  resource: PropTypes.string,
  action: PropTypes.string,
};

export default DynamicItem;
